export const POST_CHECKOUT_REQUEST = "POST_CHECKOUT_REQUEST";
export const POST_CHECKOUT_SUCCESS = "POST_CHECKOUT_SUCCESS";
export const POST_CHECKOUT_ERROR = "POST_CHECKOUT_ERROR";
export const SET_CHECKOUT_FIELD = "SET_CHECKOUT_FIELD";
